export default "__VITE_ASSET__Gy3zs6n0__"